import type { IcIcon } from "./types";

export const IcArrowRight: IcIcon = (properties) => (
  <svg height="8" viewBox="0 0 4 8" width="4" {...properties}>
    <path d="M4 4 0 0v8z" fill="currentColor" />
  </svg>
);
